// extracted by mini-css-extract-plugin
export default {"continent":"Countries__continent-j5sLb"};